import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { grey } from './colors';
import { buildPaletteFromMetadata, type Token } from './panw-palette/token-metadata';

const textTokens = (mode: PaletteMode): Token[] => [
  { propertyPath: 'bold', tokenName: '--semantic-text-bold' },
  { propertyPath: 'default', tokenName: '--semantic-text-default' },
  { propertyPath: 'disabled', tokenName: '--semantic-text-disabled' },
  { propertyPath: 'info', tokenName: '--semantic-text-info' },
  { propertyPath: 'primary', tokenName: '--semantic-text-default' },
  { propertyPath: 'secondary', tokenName: '--semantic-text-default' },
  { propertyPath: 'placeholder', tokenName: '--semantic-text-placeholder' },
  { propertyPath: 'selected', tokenName: '--semantic-text-selected' },
  { propertyPath: 'link', tokenName: '--semantic-text-link' },
  { propertyPath: 'linkHover', tokenName: '--semantic-text-link-hover' },
  // once we flip the feature flag, we can clean references to these colors up
  {
    propertyPath: 'inversePrimary',
    tokenName: mode === 'light' ? '--semantic-text-default' : '--semantic-text-inverse',
  },
  { propertyPath: 'inverseSecondary', tokenName: '--semantic-text-inverse' },
  {
    propertyPath: 'navigationHeader',
    tokenName: mode === 'light' ? '--semantic-text-inverse' : '--semantic-text-default',
  },
  { propertyPath: 'accent', tokenName: '--semantic-text-default' },
  { propertyPath: 'warning', tokenName: '--semantic-text-warning' },
];

export const textTokenMetadata = {
  componentName: 'text',
  tokens: textTokens,
};

export const text = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['text'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return buildPaletteFromMetadata<PaletteOptions['text']>(textTokens(mode), tokens);
  }

  const accent = grey[300];
  return mode === 'light'
    ? {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        bold: grey[950],
        default: grey[600],
        selected: grey[600],
        info: grey[800],
        link: grey[800],
        linkHover: grey[600],
        warning: grey[600],
        // ^^^
        primary: grey[950],
        secondary: grey[600],
        placeholder: grey[600],
        disabled: grey[300],
        inversePrimary: grey[50],
        inverseSecondary: grey[200],
        navigationHeader: grey[200],
        accent,
      }
    : {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        bold: grey[50],
        default: grey[200],
        selected: grey[200],
        info: grey[200],
        link: grey[200],
        linkHover: grey[200],
        warning: grey[200],
        // ^^^
        primary: grey[50],
        secondary: grey[200],
        placeholder: grey[200],
        disabled: grey[500],
        inversePrimary: grey[950],
        inverseSecondary: grey[600],
        navigationHeader: grey[200],
        accent,
      };
};
